module.exports = __webpack_public_path__ + "38066f42407a1bebd0b1658e2423d920.jpeg";